import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, {
  Path,
  G,
  Defs,
  Circle,
  Stop,
  LinearGradient,
} from "react-native-svg";

import { uniqueId } from "lodash";

import { isWeb } from "../../../../../helpers/utils";

export default function MariNormalIcon({ onPress }) {
  const filterId = "filter0_d_MariNormalIcon" + uniqueId();
  const gradientId = "paint0_linear_MariNormalIcon" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";

  return (
    <TouchableOpacity onPress={onPress}>
      <Svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G filter={filterUrl}>
          <Circle cx="33" cy="29" r="28" fill={gradientUrl} />
          <Path
            d="M27.0698 41.0685C31.5064 43.1742 36.3034 43.726 40.7963 40.4492"
            stroke="#243251"
            strokeWidth="1.47036"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M21.3945 30.1679C22.9057 30.1679 24.1308 28.9428 24.1308 27.4316C24.1308 25.9204 22.9057 24.6953 21.3945 24.6953C19.8833 24.6953 18.6582 25.9204 18.6582 27.4316C18.6582 28.9428 19.8833 30.1679 21.3945 30.1679Z"
            fill="#243251"
          />
          <Path
            opacity="0.61"
            d="M20.8539 27.0838C21.2395 27.0838 21.5521 26.7712 21.5521 26.3856C21.5521 26.0001 21.2395 25.6875 20.8539 25.6875C20.4683 25.6875 20.1558 26.0001 20.1558 26.3856C20.1558 26.7712 20.4683 27.0838 20.8539 27.0838Z"
            fill="white"
          />
          <Path
            d="M17.3857 20.8223C18.4636 20.0168 19.74 19.5191 21.0786 19.3823C22.4173 19.2454 23.7679 19.4746 24.9865 20.0453"
            stroke="#243251"
            strokeWidth="1.47036"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M44.1181 31.0585C45.6293 31.0585 46.8544 29.8334 46.8544 28.3222C46.8544 26.811 45.6293 25.5859 44.1181 25.5859C42.6069 25.5859 41.3818 26.811 41.3818 28.3222C41.3818 29.8334 42.6069 31.0585 44.1181 31.0585Z"
            fill="#243251"
          />
          <Path
            opacity="0.61"
            d="M43.4647 27.9607C43.8503 27.9607 44.1629 27.6482 44.1629 27.2626C44.1629 26.877 43.8503 26.5645 43.4647 26.5645C43.0792 26.5645 42.7666 26.877 42.7666 27.2626C42.7666 27.6482 43.0792 27.9607 43.4647 27.9607Z"
            fill="white"
          />
          <Path
            d="M40.6724 20.7095C41.0553 20.1968 41.5606 19.7883 42.1421 19.5212C42.7236 19.2542 43.3628 19.1371 44.0012 19.1808C44.6396 19.2245 45.2569 19.4275 45.7966 19.7713C46.3363 20.115 46.7813 20.5886 47.0908 21.1487"
            stroke="#243251"
            strokeWidth="1.47036"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </G>
        <Defs>
          {isWeb ? (
            <filter
              id={filterId}
              x="0"
              y="0"
              width="66"
              height="66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          ) : null}
          <LinearGradient
            id={gradientId}
            x1="5"
            y1="1"
            x2="44.4204"
            y2="45.7669"
            gradientUnits="userSpaceOnUse"
          >
            <Stop offset="0.374593" stopColor="#00FFD1" />
            <Stop offset="1" stopColor="#239C9D" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
